import { useUser } from "@/components/UserProvider";
import {
  ACTION_PERMISSION_KEYS,
  ACTION_PERMISSION_VALUES,
} from "@/lib/data/static/permissionOptions";

/** View / create / update flags for matter insurance and vehicles (matter details tabs). */
export function useMatterInsuranceVehiclePermissions() {
  const { hasActionPermission } = useUser();

  return {
    hasCreateInsurancePermission: hasActionPermission(
      ACTION_PERMISSION_KEYS.matterInsurance,
      ACTION_PERMISSION_VALUES.create,
    ),
    hasViewInsurancePermission: true,
    hasUpdateInsurancePermission: hasActionPermission(
      ACTION_PERMISSION_KEYS.matterInsurance,
      ACTION_PERMISSION_VALUES.update,
    ),
    hasCreateVehiclePermission: hasActionPermission(
      ACTION_PERMISSION_KEYS.matterVehicle,
      ACTION_PERMISSION_VALUES.create,
    ),
    hasViewVehiclePermission: true,
    hasUpdateVehiclePermission: hasActionPermission(
      ACTION_PERMISSION_KEYS.matterVehicle,
      ACTION_PERMISSION_VALUES.update,
    ),
  };
}
